<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { EventBus } from '@/assets/js/event-bus';

interface Props {
  title?: string;
  icon?: string;
  tooltip?: string;
  disable?: boolean;
  closeBox?: boolean;
  removeBottomPadding?: boolean;
  framingModalHide?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  icon: '',
  tooltip: '',
  disable: false,
  closeBox: false,
  removeBottomPadding: false,
  framingModalHide: false,
});

const open = ref<boolean>(true);

onMounted(() => {
  if (props.disable || props.closeBox) {
    open.value = false;
  }
});

watch(
  () => props.disable,
  value => {
    if (value) {
      open.value = false;
    } else if (props.disable === false) {
      open.value = true;
    }
  }
);

function handleOpen() {
  if (props.framingModalHide) {
    EventBus.emit('framing.modal.show.hide', false);
  }
  if (!props.disable) {
    open.value = !open.value;
  }
}
</script>

<template>
  <div class="uk-card uk-card-default uk-border-rounded uk-margin-small">
    <div
      class="uk-flex uk-flex-middle uk-flex-between uk-padding-small uk-background-tertiary uk-border-rounded-top"
      :class="{
        'uk-border-rounded-bottom': !open,
      }"
    >
      <div class="uk-flex uk-flex-middle uk-width-1-1">
        <img style="width: 3%" class="uk-margin-small-right" :src="icon" />
        <h3 class="uk-text-bolder" style="margin: 0">{{ title }}</h3>
      </div>
      <img
        :uk-tooltip="tooltip"
        :style="{
          width: '3%',
          cursor: disable ? 'default' : 'pointer',
          transform: !open ? 'rotate(0deg)' : 'rotate(180deg)',
          opacity: disable ? '.5' : '1',
        }"
        @click="handleOpen"
        :src="`/icons/black/icon-black-outline-node.svg`"
      />
    </div>
    <div
      v-if="open"
      class="uk-padding-small"
      :class="{ 'modal-bottom-paddind-remove': removeBottomPadding }"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modal-bottom-paddind-remove {
  padding-bottom: 0px !important;
}

.uk-card {
  transition: all 0.3s ease;

  .uk-background-tertiary {
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      opacity: 0.9;
    }
  }

  img {
    transition: transform 0.3s ease;
  }
}
</style>
